import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class SearchAISummariesEntitiesUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (): Promise<any> => {
        return await this._aiRepository.searchAISummariesEntities();
    }
}

export const SearchAISummariesEntitiesUseCaseName = "SearchAISummariesEntitiesUseCaseName";